import React from 'react';
import {
  BookingButtonModeBookingContent,
  BookingButtonWrapper,
  BookingSectionContainer,
  StyledScheduleAppointmentFixedMobileFooter
} from './styles';
import { LoadingBookingOptions } from './LoadingBookingOptions';
import { ProviderBookingButton } from '@kyruus/provider-components';
import AvailableWithinDays from './AvailableWithinDays';
import { PMCConfig, ProviderMatchProviderV9 } from '@kyruus/types';
import messages from '../../lib/messages';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { getBookingStrategy, showAvailableWithinDays } from './utilities';
import { Case, Default, Switch } from '../Switch';
import { BookingStrategies } from '../../types';

export interface ScheduleAppointmentFixedMobileFooterProps {
  provider: ProviderMatchProviderV9;
  loadingBookingInfo: boolean;
  config: PMCConfig;
  availabilityDensityBest?: string;
  bookOnlineUrl?: string;
  onBook: (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => void;
}

function ScheduleAppointmentFixedMobileFooter(
  props: ScheduleAppointmentFixedMobileFooterProps & WrappedComponentProps
) {
  const bookingStrategy = getBookingStrategy(props.config, props.provider);

  return (
    <StyledScheduleAppointmentFixedMobileFooter>
      <Switch on={bookingStrategy}>
        <Case when={BookingStrategies.Button}>
          <BookingSectionContainer
            aria-label={props.intl.formatMessage(messages.bookingHeader)}
            showBorder={false}
          >
            <LoadingBookingOptions loading={props.loadingBookingInfo} />
            {!props.loadingBookingInfo && (
              <BookingButtonModeBookingContent>
                <BookingButtonWrapper>
                  <ProviderBookingButton
                    provider={props.provider}
                    modalDisplayConfig={props.config.modal_display || {}}
                    onClick={props.onBook}
                    href={props.bookOnlineUrl}
                  />
                </BookingButtonWrapper>
                {showAvailableWithinDays(props) && (
                  <AvailableWithinDays
                    availabilityDensityBest={props.availabilityDensityBest}
                  />
                )}
              </BookingButtonModeBookingContent>
            )}
          </BookingSectionContainer>
        </Case>
        <Default>Not Implemented</Default>
      </Switch>
    </StyledScheduleAppointmentFixedMobileFooter>
  );
}

const IntlScheduleAppointmentFixedMobileFooter: React.ComponentType<ScheduleAppointmentFixedMobileFooterProps> =
  injectIntl(ScheduleAppointmentFixedMobileFooter);

export { IntlScheduleAppointmentFixedMobileFooter as ScheduleAppointmentFixedMobileFooter };
